import { StyledMetaverseSectionItem } from './MetaverseSectionItem.styled';
import { openUrl } from '../../utils';
import useIsMobile from '../../hooks/useIsMobile';

const MetaverseSectionItem = ({ width, item = null }) => {
  const isMobile = useIsMobile();
  const {image, compatible, name, subtitle, description, url} = (item || {image: '', name: '', subtitle: null, description: '', url: null, compatible: false});
  return (
    <StyledMetaverseSectionItem $width={width} $placeholder={!item} onClick={() => openUrl(url)}>
      <div className='metaverse-section-item-image'>
        <div className='metaverse-section-item-image-border'>
          <div className='metaverse-section-item-image-internal-border'>
            <div style={{overflow: 'hidden', height: '100%', width: '100%'}}>
              <img src={image} />
            </div>
            {/*compatible && !isMobile && <div className='metaverse-section-item-compatible-hover'>
	      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', justifyContent: 'center', alignItems: 'center'}}>
                <img src='/assets/heart.svg' />
	        <div>BaseJump Compatible</div>
              </div>
            </div>*/}
          </div>
        </div>
      </div>
      {isMobile && <div className='metaverse-section-item-time'>{subtitle}</div>}
      <div className='metaverse-section-item-name'>{name}</div>
      {!isMobile && <div className='metaverse-section-item-description'>{description}</div>}
      {!isMobile && subtitle && <div className='metaverse-section-item-platform-wrapper'>
        <div className='metaverse-section-item-platform'>
          <div className='metaverse-section-item-plafrorm-name'>{subtitle}</div>
        </div>
        <div className='metaverse-section-item-icon metaverse-section-item-icon-link'>
          <img src='/assets/link.svg' />
        </div>
      </div>}
    </StyledMetaverseSectionItem>
  );
};

export default MetaverseSectionItem;
